export default __webpack_public_path__ + "static/media/dr-avatar-1.21715f5a.png";